import { DotLoading, List, Modal, Popup, Tag, Tabs } from "antd-mobile";
import {
  AppstoreOutline,
  CollectMoneyOutline,
  EditSOutline,
  FileOutline,
  UserOutline,
} from "antd-mobile-icons"; // Import the icon component from react-icons or any other icon library you're using

import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import { momentDate, timeTableDayFromNumber } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const NotificationList = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  let dayOrderInDayName = context.settingValue(
    "attendance_dayorder_as_day_name"
  );

  const [loader, setLoader] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [dataList, setDataList] = useState([]);

  const [generalData, setGeneralData] = useState([]);

  const [redirect, setRedirect] = useState([]);

  const [holiday, setHoliday] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedType, setSelectedType] = useState("all");
  const [activeTab, setActiveTab] = useState("all");
  const [semDate, setSemDate] = useState([]);
  const [todayDayOrder, setTodayDayOrder] = useState([]);

  const getAttendanceDate = () => {
    if (props.timeTableDate) return props.timeTableDate;
    let x = context.getStorage("mob_attendance_date");
    return x && x != null ? x : momentDate(new Date(), "YYYY-MM-DD");
  };

  const [attendanceDate, setAttendaceDate] = useState(getAttendanceDate());

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };

  useEffect(() => {
    loadData();
  }, [selectedType]);

  const loadData = () => {
    setLoader(true);
    setHoliday([]);
    setDataList([]);
    const form = new FormData();
    form.append("type", "staff");
    form.append("selectedType", selectedType);
    form.append("academic_department", context.user.emp_academic_department);
    form.append("uuid", context.user.uuid);
    form.append("role_id", context.user.emp_role_id);
    form.append("emp_id", context.user.id);
    axios.post(ServiceUrl.MOB.MY_NOTIFICATION, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
      }
      setLoader(false);
    });
  };

  const onDaySelect = () => {
    context.setStorage("mob_attendance_date", selectedDate);
    setAttendaceDate(selectedDate);
    setShowPopUp(false);
  };

  useEffect(() => {
    if (selectedDate && selectedDate.length > 2) {
      context.setStorage("mob_attendance_date", selectedDate);
      setAttendaceDate(selectedDate);
    }
    Modal.clear();
  }, [selectedDate]);

  const generalEntryClick = (special = false) => {
    if (special == "elective")
      navigate("/staff/app/custom-attendance-entry/elective");
    else if (special) navigate("/staff/app/custom-attendance-entry/special");
    else navigate("/staff/app/custom-attendance-entry");
  };

  const showDatePickerModal = () => {
    Modal.show({
      closeOnMaskClick: true,
      title: "Select Date",
      showCloseButton: true,
      content: (
        <div
          className="text-center "
          style={{ marginTop: "5px", padding: "5px" }}
        >
          <Form.Control
            type="date"
            max={momentDate(new Date(), "YYYY-MM-DD")}
            onChange={(e) => {
              setSelectedDate(e.target.value);
            }}
            min={semDate?.start_date}
          />
        </div>
      ),
    });
  };

  return (
    <>
      <div className="leave">
        <Tabs
          className="bg-white"
          activeKey={selectedType}
          onChange={(k) => setSelectedType(k)}
        >
          <Tabs.Tab title="Common" key="all" />
          <Tabs.Tab title="Department" key="department" />
          <Tabs.Tab title="Role" key="role" />
          <Tabs.Tab title="Private" key="private" />
        </Tabs>
      </div>

      <div class="chat-list mt-2">
        {dataList &&
          dataList.length > 0 &&
          dataList.map((item) => {
            return (
              <>
                <div
                  class={
                    item.history_count == 1 ? "chat-box active" : "chat-box "
                  }
                  onClick={(e) =>
                    linkClick("/staff/app/notification/read/" + item.id)
                  }
                >
                  <div class="chat-details">
                    <div class="text-head">
                      <h4>{item.notification_title}</h4>
                      <p class="time">
                        {momentDate(item.created_on, "DD-MM-YYYY H:MM")}
                      </p>
                    </div>
                    <div class="text-message">
                      <p>
                        {" "}
                        {item.notification_content.length > 50
                          ? item.notification_content
                              .replace(/(<([^>]+)>)/gi, "")
                              .substring(0, 150) + "....."
                          : item.notification_content.replace(
                              /(<([^>]+)>)/gi,
                              ""
                            )}
                      </p>
                    </div>
                    <div class="sent">Sent By: {item.addedby}</div>
                  </div>
                </div>
              </>
            );
          })}
      </div>
    </>
  );
};
export default NotificationList;
